import React from 'react';
import { handleADA } from '@dsg-tech/homefield-utils';
import { HomefieldIconArrowRight } from '@dsg-tech/homefield-react-icons';
import './styles/CustomArrows.scss';

type CustomNextArrowProps = {
  className: string;
  onClick: () => void;
};

/**  Carousel next arrow customization */
// arrow-right
const CustomNextArrow = (props: CustomNextArrowProps) => {
  const { className, onClick } = props;
  return (
    <button
      type="button"
      className={className}
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      onKeyDown={(e) => {
        handleADA(e, 'button', onClick);
      }}
      tabIndex={0}
      aria-label="custom arrow">
      <HomefieldIconArrowRight width="20px" height="20px" />
    </button>
  );
};

export default CustomNextArrow;
